import React from "react";
import { getRegistryIcon } from "./icon-registry";

interface BadgeIconProps {
  icon: string;
  className?: string;
}

export const BadgeIcon: React.FC<BadgeIconProps> = ({ icon, className }) => {
  const IconComponent = getRegistryIcon(icon);

  if (IconComponent) {
    return <IconComponent className={className} />;
  }

  // Fallback: render as emoji text
  return <span className={className}>{icon}</span>;
};
